import { useDeleteGroupMutation } from '@entities/clients/rtk-query.ts';
import { useGroup } from '@entities/common/groups';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@shared/hooks';
import { openDialogModal, showPopup } from 'library/redux/modal';

/**
 * Хук контролирует удаление программы и диалог удаления
 */

export const useGroupDelete = (programId: number) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { group, removeGroup } = useGroup(programId);
  const [deleteGroup] = useDeleteGroupMutation();
  const remove = async () => {
    // Делаем апи-запрос на удаление и удаляем программу из списка
    if (!group) return;

    try {
      removeGroup(group.id);
      // if (isOpen) navigate(getUrl());
      await deleteGroup({ groupId: String(group.id) });
    } catch (error) {
      // TODO востановить программу в случае ошибки удаления

      // TODO окно оповещения об ошибке
      console.error(error);
    }
  };
  const removeGroupDialog = async () => {
    dispatch(
      openDialogModal({
        isNeedClose: true,
        title: 'Удаление группы',
        text:
          'Удаление группы из списка не затронет клиентов, которые в ней находятся\n' +
          '\n' +
          'Вы действительно хотите удалить данную группу?',
        confirmText: 'Да',
        confirm: () => {
          remove();
          navigate('/clients/groups/');
          dispatch(
            showPopup({
              type: 'success',
              text: `Группа успешно удалена`,
            })
          );
        },
        declineText: 'Нет',
      })
    );
  };
  return {
    removeGroup: removeGroupDialog,
  };
};
